export const commonStyles = (FOUNDATIONS, FONT, VARIANT_TOKENS) => ({
    rootContainer: {
        position: 'relative',
        width: 'fit-content',
        height: 'auto',
        overflow: 'hidden',
        border_radius: FOUNDATIONS.radius_100,
        ...VARIANT_TOKENS?.rootContainer,
    },
    overlay: {
        position: 'absolute',
        top: '0',
        left: '0',
        height: '100%',
        z_index: 1,
        ...VARIANT_TOKENS?.overlay,
    },
    // colors are open, no color tokens are provided from design,
    // but we put a default value here and the opacity token
    overlayColor: `rgba(0, 0, 0, ${FOUNDATIONS.alpha_400})`,
    barColor: `rgba(87, 87, 87, ${FOUNDATIONS.alpha_400})`,
});
//# sourceMappingURL=commonStyles.js.map